export enum UserStatus {
  A = 'A', // Only 1 active user per user_id / username / email
  I = 'I',
  D = 'D' // 'Flagged for Deletion',  // Will be deleted after X days, can be undeleted
  // X = 'Deleted'                // Personal Info has been removed, cannot be undeleted
  // R = 'Password Reset Forced', // Needs to change password before logging in
  // P = 'Password Reset Sent'    // May pick a new password, can still login with current PW
}
